import { HttpClient, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, tap } from 'rxjs/operators';

import { FlashyCustomDataService, FlashyStoreService } from '@flashy/store';
import { IFlashyUiImageFile } from '@flashy/store/products';
import { FlashyPagination, IFlashyServerResponse } from '@shared/domain';

@Injectable({
  providedIn: 'root',
})
export class FlashyFileService extends FlashyCustomDataService<IFlashyUiImageFile> {
  uniqueKey: keyof IFlashyUiImageFile = 'id';
  isLoading$ = this.storeService.isLoading$;

  constructor(
    private storeService: FlashyStoreService,
    private http: HttpClient
  ) {
    super();
  }

  getAll(params?: object): Observable<FlashyPagination<IFlashyUiImageFile>> {
    return this.storeService
      .makeHttpRequest<
        FlashyPagination<IFlashyUiImageFile>
      >('GET', 'files', {}, params)
      .pipe(
        tap(({ results, total }) => {
          this.setCount(total);
          if (!results.length) {
            this.setEntities([]);
          } else {
            this.addEntities(results);
          }
        }),
        catchError((error) => {
          this.setEntities([]);
          this.setCount(0);
          return of(error);
        })
      );
  }

  upload(formData: FormData): Observable<IFlashyUiImageFile[]> {
    const url = this.storeService.getHttpUrl('file');
    const req = new HttpRequest('POST', url, formData, {
      responseType: 'json',
    });
    return this.http.request(req).pipe(
      filter(
        (ev): ev is HttpResponse<IFlashyServerResponse<IFlashyUiImageFile[]>> =>
          ev instanceof HttpResponse
      ),
      map((ev) => ev.body!.data),
      tap((files) => {
        this.addEntities(files);
      })
    );
  }

  delete(file: IFlashyUiImageFile): Observable<boolean> {
    return this.storeService
      .makeHttpRequest<boolean>('DELETE', `file/${file.id}`)
      .pipe(
        tap(() => {
          this.deleteEntities([file]);
        })
      );
  }
}
